import axiosInstance from "../utils/axiosInstance";

// ---------- Employee ----------
// Admin-on-behalf (employeeId props object present) -> admin endpoint for that
// employee; otherwise the logged-in employee's own claim.
export async function submitReimbursement(formData, employeeId) {
  const url = employeeId?.employeeId
    ? `/reimbursements/employee/${employeeId.employeeId}`
    : `/reimbursements`;
  const { data } = await axiosInstance.post(url, formData);
  return data;
}

// When called from the admin "employee details" view, `employeeId` is the props
// object carrying the viewed employee's id -> fetch THAT employee's claims via
// the admin endpoint. Otherwise (logged-in employee) fetch the caller's own.
export async function fetchMyReimbursements(employeeId) {
  if (employeeId?.employeeId) {
    const { data } = await axiosInstance.get(
      `/reimbursements/employee/${employeeId.employeeId}`,
    );
    return data;
  }
  const { data } = await axiosInstance.get(`/reimbursements/claims`);
  return data;
}

export async function cancelReimbursement(id, employeeId) {
  const url = employeeId?.employeeId
    ? `/reimbursements/${id}/admin-cancel`
    : `/reimbursements/${id}/cancel`;
  const { data } = await axiosInstance.put(url);
  return data;
}

// ---------- Admin ----------
export async function fetchAllReimbursements(status) {
  const { data } = await axiosInstance.get(`/reimbursements`, {
    params: status ? { status } : {},
  });
  return data;
}

export async function updateReimbursementStatus(id, payload) {
  const { data } = await axiosInstance.put(`/reimbursements/${id}/status`, payload);
  return data;
}

export async function markReimbursementPaid(id) {
  const { data } = await axiosInstance.put(`/reimbursements/${id}/mark-paid`);
  return data;
}
